import React, { useState } from "react";
import axios from "axios";
import Loading from "../loading/Loading"; // Ajustá la ruta si es necesario

const CsvUploader = () => {
  const [file, setFile] = useState(null);
  const [anio, setAnio] = useState("");
  const [mes, setMes] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      setFile(null);
      setMensaje("⚠️ No se seleccionó ningún archivo.");
      return;
    }

    if (!selectedFile.name.endsWith(".csv")) {
      setFile(null);
      setMensaje("⚠️ El archivo debe ser un .csv");
      return;
    }

    setFile(selectedFile);
    setMensaje("");
    console.log("📁 Archivo seleccionado:", selectedFile.name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file || !anio || !mes) {
      setMensaje("❗ Por favor, completá todos los campos.");
      return;
    }

    setLoading(true);
    setMensaje("");

    try {
      const reader = new FileReader();

      reader.onload = async (event) => {
        const csvText = event.target.result;

        try {
          const response = await axios.post(
            "https://us-central1-inprojuy-f1173.cloudfunctions.net/app/api/estadisticas/cargar-csv",
            {
              anio,
              mes,
              csvText,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          console.log("✅ Respuesta del servidor:", response.data);
          setMensaje(`✔️ ${response.data.mensaje}. Registros: ${response.data.cantidad}`);
        } catch (error) {
          console.error("❌ Error al subir el archivo:", error);
          setMensaje("❌ Error al subir el archivo.");
        } finally {
          setLoading(false);
        }
      };

      reader.onerror = () => {
        setLoading(false);
        setMensaje("❌ Error leyendo el archivo.");
      };

      reader.readAsText(file); // 📥 Convertir archivo CSV a texto

    } catch (error) {
      console.error("❌ Error general:", error);
      setMensaje("❌ Error inesperado.");
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Cargar CSV de Estadísticas</h2>
      {loading ? (
        <Loading />
      ) : (
        <form onSubmit={handleSubmit}>
          <input
            type="number"
            placeholder="Año (ej: 2025)"
            value={anio}
            onChange={(e) => setAnio(e.target.value)}
          />
          <input
            type="number"
            placeholder="Mes (ej: 6)"
            value={mes}
            onChange={(e) => setMes(e.target.value)}
          />
          <input type="file" accept=".csv" onChange={handleFileChange} />
          {file && <p>📄 Archivo seleccionado: {file.name}</p>}
          <button type="submit" disabled={!file || loading}>
            Cargar CSV
          </button>
        </form>
      )}
      {mensaje && <p>{mensaje}</p>}
    </div>
  );
};

export default CsvUploader;
